// extracted by mini-css-extract-plugin
module.exports = {"registered_charges_table":"_3QanSwM"};